/* eslint-disable no-unused-vars */
import React from "react";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";

export default function PAutoCompleteMultiSelect(props) {
  return (
    <Autocomplete
      multiple
      value={props.value}
      size={props.size ? "small" : props.size}
      options={props.options}
      getOptionLabel={(option) => option.label}
      onChange={(e, value) => {
        if (props.onChange) props.onChange(e, value);
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option.label}
            size="small"
            key={index}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          onFocus={(e) => {
            if (props.onFocus) props.onFocus(e);
          }}
          onBlur={(e) => {
            if (props.onBlur) props.onBlur(e);
          }}
        />
      )}
    />
  );
}
